// scroll-to-top.component.ts
import { Component, HostListener, signal } from '@angular/core';

@Component({
  selector: 'ui-scroll-to-top',
  standalone: true,
  imports: [],
  template: `
    @if (isVisible()) {
      <button (click)="scrollToTop()" class="scroll-to-top-btn" aria-label="Nach oben scrollen">↑</button>
    }
  `,
  styles: [
    `
      .scroll-to-top-btn {
        position: fixed;
        bottom: 20px;
        right: 20px;
        width: 50px;
        height: 50px;
        border-radius: 50%;
        background-color: #007bff;
        color: white;
        border: none;
        font-size: 24px;
        cursor: pointer;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
        transition: all 0.3s ease;
        z-index: 1000;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .scroll-to-top-btn:hover {
        background-color: #0056b3;
        transform: translateY(-3px);
        box-shadow: 0 6px 12px rgba(0, 0, 0, 0.4);
      }

      .scroll-to-top-btn:active {
        transform: translateY(-1px);
      }
    `,
  ],
})
export class ScrollToTopComponent {
  isVisible = signal(false);

  @HostListener('window:scroll', [])
  onWindowScroll() {
    // Button wird sichtbar, wenn mehr als 300px gescrollt wurde
    this.isVisible.set(window.scrollY > 300);
  }

  scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: 'instant',
    });
  }
}
